import {
  Formats,
  FormatXMLElementFn,
  IntlMessageFormat,
  Options,
} from 'intl-messageformat';
import type { Locale } from './core/interfaces/Locale';

export type RichTextFormatter = FormatXMLElementFn<JSX.Element>;

export class MessageFormatter<
  Props extends Record<string, any>
> extends String {
  formatter: IntlMessageFormat;

  translation: string;

  constructor(
    translation: string,
    locale: Locale,
    overrideFormats?: Partial<Formats>,
    options?: Options
  ) {
    super(translation);
    this.translation = translation;
    this.formatter = new IntlMessageFormat(
      translation,
      locale,
      overrideFormats,
      options
    );
  }

  format = <Output = Exclude<React.ReactNode, null | undefined>>(
    values: Props
  ) => this.formatter.format<Output>(values);
}
